<template>
    <div class="d-inline-block">
    	<button @click="modal.show()" class="btn btn-outline-danger btn-icon-sm"><span class="material-icons-outlined">delete</span></button>
        <div class="modal" :id="id">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Czy napewno chcesz usunąc?</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="py-3">
                    {{text}}
                    	<div class="text-center">
                    		<button class="btn btn-outline-secondary" @click="modal.hide(); $emit('cancel');">Anuluj</button>
                    		<button class="btn btn-danger" @click="$emit('ok'); modal.hide()">Tak</button>
                    	</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';
export default {
    name: 'DeleteConfirm',
    props: ['text'],
    data: function() {
        return {
            id: 'modal' + Math.round(Math.random() * 100000),
            modal: null,
        }
    },
    mounted() {
        this.modal = new Modal(document.getElementById(this.id))
        let vm = this;
        document.getElementById(this.id).addEventListener('hidden.bs.modal', function(event) {
	            // vm.triggerModal(false);

        })
    },
    methods: {
      
    },
}
</script>